import React, { useRef, useState } from "react";
import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import CompleteCategoriesModal from "./AddScriptModals/CompleteCategoriesModal/CompleteCategoriesModal";
import AddScriptModal from "./AddScriptModals/AddScriptModal/AddScriptModal";
import AddIcon from "@mui/icons-material/Add";
function AddScriptBanner({
  onClose,
  categoryName,
  setCategoryName,
  scriptText,
  setScriptText,
  onSave,
}) {
  const [modalType, setModalType] = React.useState(null);

  const renderContent = () => {
    if (modalType === "add_script") {
      return (
        <AddScriptModal
          onClose={() => setModalType(null)}
          categoryName={categoryName}
          setCategoryName={setCategoryName}
          scriptText={scriptText}
          setScriptText={setScriptText}
          onSave={() => {
            onSave(); // вызываем функцию родителя
            setModalType(null); // закрываем модалку
          }}
        />
      );
    }
    return null;
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">Скрипти</Typography>
        <Button
          sx={{
            color: "var(--darkPurpleBodyColor) !important",
            textTransform: "none",
            fontSize: "16px",
          }}
          onClick={() => setModalType("add_script")}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AddIcon /> Додати скрипт
          </Box>
        </Button>
      </Box>

      <Dialog
        open={Boolean(modalType)}
        onClose={() => setModalType(null)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent className="rmui-card" sx={{ borderRadius: "15px" }}>
          {renderContent()}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default AddScriptBanner;
